import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TDR, formatDisplayPhoneNumber } from 'tdr-common';
import { analytics } from '../../helpers/analytics';
import { RESULT_CLICKED } from '../../helpers/analytics/constants';
import { NoticeTile } from '../notice-cards/NoticeTile';

export interface DirectInboundNoticeProps {
	restaurant: TDR.Restaurant;
	phone?: string;
	email?: string;
}

export const DirectInboundNotice = ({ restaurant, phone, email }: DirectInboundNoticeProps) => {
	const { t } = useTranslation();
	const restaurantName = restaurant?.displayName || restaurant?.name || '';

	useEffect(() => {
		analytics.track('Notice Viewed', {
			notice: 'DirectInboundNotice',
			restaurantId: restaurant?.id,
			hasPhone: !!phone,
			hasEmail: !!email
		});
	}, [restaurant?.id, phone, email]);

	return (
		<div className="grid w-full grid-cols-1 justify-items-center gap-4 xl:grid-cols-2 xl:items-stretch">
			{phone ? (
				<NoticeTile
					icon="phone"
					title={t('large_group_inbound.call_title', { restaurantName, defaultValue: `Call ${restaurantName}` })}
					subtitle={formatDisplayPhoneNumber(phone)}
					href={`tel:${phone}`}
					onClick={() => {
						analytics.track(RESULT_CLICKED, { resultType: 'phone' });
						analytics.track('Redirected to Phone Number', { phoneNumber: phone });
					}}
					data-cy="direct-inbound-phone-card"
				/>
			) : null}

			{email ? (
				<NoticeTile
					icon="email"
					title={t('large_group_inbound.email_title', { restaurantName, defaultValue: `E-mail ${restaurantName}` })}
					subtitle={email}
					href={`mailto:${email}`}
					onClick={() => {
						analytics.track(RESULT_CLICKED, { resultType: 'email' });
						analytics.track('Redirected to Email');
					}}
					data-cy="direct-inbound-email-card"
				/>
			) : null}
		</div>
	);
};
